import { Switch } from '@headlessui/react';
import { CalendarDaysIcon, ClockIcon, PlusCircleIcon, XMarkIcon, TrashIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import DatePickerDialog from './DatePickerDialog';
import ScheduleVenueDialog from './ScheduleVenueDialog';
import { ArrowUpOnSquareIcon } from '@heroicons/react/24/solid';
import { formatDate, showToast, timeFormatNonUTC } from '../../Utils';
import MapDialog from './MapDialog';
import { createVenue, editVenue, getVenueDetail, getVenueScheduleClosed, updateVenueScheduleClosed } from '../../api/VenueInteractor';
import { useParams } from 'react-router-dom';
import AddScheduleVenueDialog from './AddScheduleVenueDialog'
import DaySelectionDialog from './dialog/DaySelectionDialog'
import TimeSelectionDialog from './dialog/TimeSelectionDialog'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import InputMask from 'react-input-mask';
import { Tabs, Tab } from "../Tabs";
import DatePicker from './DatePicker';
import ConfirmationDialog from './dialog/ConfirmationDialog';

const inputClass = "w-full text-xs bg-[#F5F5F5] rounded-lg py-2.5 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"
const textarea = "w-full h-36 text-xs bg-[#F5F5F5] rounded-lg py-2 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"

const addOnList = [
  {
    id: "0",
    name: "Jual Makanan & Minuman",
    image: "/facilities/ic-jual-makanan-&-minuman.svg"
  },
  {
    id: "1",
    name: "WIFI",
    image: "/facilities/ic-wifi.svg"

  },
  {
    id: "2",
    name: "Toilet",
    image: "/facilities/ic-toilet.svg"
  },
  {
    id: "3",
    name: "Parkir Motor",
    image: "/facilities/ic-parkir-motor.svg"
  },
  {
    id: "4",
    name: "Musholla",
    image: "/facilities/ic-musholla.svg"
  },
  {
    id: "5",
    name: "Parkir Mobil",
    image: "/facilities/ic-parkir-mobil.svg"
  },
  {
    id: "6",
    name: "Tribun",
    image: "/facilities/ic-tribun.svg"
  },
  {
    id: "7",
    name: "Hot Shower",
    image: "/facilities/ic-hot-shower.svg"
  },
  {
    id: "8",
    name: "Ruang Ganti",
    image: "/facilities/ic-ruang-ganti.svg"
  },
]

const bundlinglist = [
  {
    bundlingName: "Lapang",
    icon: "/ic-field-solid.svg"
  },
  {
    bundlingName: "Fotografi",
    icon: "/ic-fotografi.svg"
  },
  {
    bundlingName: "Videografi",
    icon: "/ic-videografi.svg"
  },
  {
    bundlingName: "Wasit",
    icon: "/ic-wasit.svg"
  }
]

const downPaymentList = [10, 20, 30, 40, 50]


function CreateVenue(props) {
  const [selectedAddOns, setselectedAddOns] = useState([])
  const [loading, setLoading] = useState(false)
  let [isOpenUpdateScheduleDialog, setIsOpenUpdateScheduleDialog] = useState(false)

  //schedule state
  const [selectedDate, setSelectedDate] = useState("")
  const [selectedSlots, setSelectedSlots] = useState([])
  const [scheduleList, setScheduleList] = useState([])
  const [scheduleClosedList, setScheduleClosedList] = useState([])

  //package state 
  const [packageList, setPackageList] = useState([])
  const [selectedBundling, setSelectedBundling] = useState([bundlinglist[0]])
  const [packageName, setPackageName] = useState("")
  const [packagePrice, setPackagePrice] = useState("")
  const [packagePromoPrice, setPackagePromoPrice] = useState("")

  //venue image
  const [venueImage, setVenueImage] = useState(null)
  const [venueImageUrl, setVenueImageUrl] = useState(null)

  //venue attachments
  const [attachments, setAttachments] = useState([])
  const [attachmentsUrl, setAttachmentsUrl] = useState([])

  const hiddenFileInput = React.useRef(null);
  const attachmentsRef = React.useRef(null);



  //venue form 
  const [venueName, setVenueName] = useState("")
  const [venueType, setVenueType] = useState("Padel")
  const [venueDesc, setVenueDesc] = useState("")
  const [venueLat, setVenueLat] = useState("")
  const [venueLong, setVenueLong] = useState("")
  const [venueAddress, setVenueAddress] = useState("")
  const [venueGeocodeAddress, setVenueGeocodeAddress] = useState("")
  const [venueDayOfService, setVenueDayOfService] = useState("")
  const [venueOpenHour, setVenueOpenHour] = useState("")
  const [venueCloseHour, setVenueCloseHour] = useState("")
  const [venueIsDp, setVenueIsDp] = useState(false)
  const [venueMinimalDp, setVenueMinimalDp] = useState(0)
  const [venueTos, setVenueTos] = useState("")
  const [venueFacility, setVenueFacility] = useState("")
  const [isReset, setIsReset] = useState(true)
  const [closeNote, setCloseNote] = useState("");

  const { venueId } = useParams();

  const [dayOpen, setDayOpen] = useState([{
    day: "Senin",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Selasa",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Rabu",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Kamis",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Jumat",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Sabtu",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Minggu",
    checked: false,
    service_times_attributes: []
  }])

  const [timeOpen, setTimeOpen] = useState([{
    id: 0,
    time: "00:00",
    checked: false
  }, {
    id: 1,
    time: "01:00",
    checked: false
  }, {
    id: 2,
    time: "02:00",
    checked: false
  }, {
    id: 3,
    time: "03:00",
    checked: false
  }, {
    id: 4,
    time: "04:00",
    checked: false
  }, {
    id: 5,
    time: "05:00",
    checked: false
  }, {
    id: 6,
    time: "06:00",
    checked: false
  }, {
    id: 7,
    time: "07:00",
    checked: false
  }, {
    id: 8,
    time: "08:00",
    checked: false
  }, {
    id: 9,
    time: "09:00",
    checked: false
  }, {
    id: 10,
    time: "10:00",
    checked: false
  }, {
    id: 11,
    time: "11:00",
    checked: false
  }, {
    id: 12,
    time: "12:00",
    checked: false
  }, {
    id: 13,
    time: "13:00",
    checked: false
  }, {
    id: 14,
    time: "14:00",
    checked: false
  }, {
    id: 15,
    time: "15:00",
    checked: false
  }, {
    id: 16,
    time: "16:00",
    checked: false
  }, {
    id: 17,
    time: "17:00",
    checked: false
  }, {
    id: 18,
    time: "18:00",
    checked: false
  }, {
    id: 19,
    time: "19:00",
    checked: false
  }, {
    id: 20,
    time: "20:00",
    checked: false
  }, {
    id: 21,
    time: "21:00",
    checked: false
  }, {
    id: 22,
    time: "22:00",
    checked: false
  }, {
    id: 23,
    time: "23:00",
    checked: false
  },])


  const handleTabChange = (event, newValue) => {
    setIsReset(true);
  };

  const updateDayOfService = (day_of_service) => {
    if (day_of_service !== "") {
      // const dayStart = day_of_service.split("-")[0].trim()
      // const dayEnd = day_of_service.split("-")[1].trim()
      const dayStart = "Senin"
      const dayEnd = "Minggu"
      let tmpDayOpen = [...dayOpen]
      let checked = false
      tmpDayOpen.forEach(item => {
        if (item.day === dayStart) {
          checked = true
        }
        item.checked = checked
        if (item.day === dayEnd) {
          checked = false
        }
      });
      // console.log("day_of_service")
      // console.log(day_of_service)
      setVenueDayOfService(day_of_service)
      setDayOpen(tmpDayOpen)
    }
  }

  const appendServiceTimes = (service_times_attributes, appendDay) => {
    const tmpServiceTimes = service_times_attributes.filter(day => day.day === appendDay).sort((a, b) => a.time_start.localeCompare(b.time_start));
    // console.log(tmpServiceTimes);
    const tmpDayOpen = [...dayOpen];
    tmpDayOpen.find(day => day.day === appendDay).service_times_attributes = tmpServiceTimes;
    setDayOpen(tmpDayOpen);
  }

  const getVenueDetailApi = () => {
    getVenueDetail(
      venueId,
      //success
      (responseJSON) => {
        //parse API response to local states
        // setVenueOpenHour(timeFormatNonUTC(responseJSON.open_hour))
        // setVenueCloseHour(timeFormatNonUTC(responseJSON.close_hour))
        // setVenueDayOfService(responseJSON.day_of_service)
        // updateDayOfService(responseJSON.day_of_service)
        // setVenueDesc(responseJSON.description)

        const service_times_attributes = responseJSON.service_times_attributes;

        appendServiceTimes(service_times_attributes, "Senin");
        appendServiceTimes(service_times_attributes, "Selasa");
        appendServiceTimes(service_times_attributes, "Rabu");
        appendServiceTimes(service_times_attributes, "Kamis");
        appendServiceTimes(service_times_attributes, "Jumat");
        appendServiceTimes(service_times_attributes, "Sabtu");
        appendServiceTimes(service_times_attributes, "Minggu");

        //facility
        // let temp = responseJSON.facilities.split(",")
        // let temp2 = []
        // //iterate to remove space
        // temp.forEach((item) => {
        //   temp2.push({
        //     name: item.replace(/\s+/g, ' ').trim()
        //   })
        // })

        // //remove empty item
        // let index = temp2.findIndex((item) => { return item == "" })


        // if (index > 0) {
        //   temp2.splice(index, 1)
        // }
        // setselectedAddOns(temp2)

        // setVenueImageUrl(responseJSON.cover)

        // let url = []
        // responseJSON.images.forEach((item) => {
        //   url.push(item.url)
        // })
        // setAttachmentsUrl(url)

        // setVenueAddress(responseJSON.location)
        setVenueName(responseJSON.name)
        setVenueType(responseJSON.sport_type)
        // setVenueIsDp(responseJSON.is_dp)
        // setVenueLat(responseJSON.latitude)
        // setVenueLong(responseJSON.longitude)
        // setVenueMinimalDp(responseJSON.minimal_dp)
        // setVenueTos(responseJSON.terms_of_service)

        //package Description format
        let tempPackage = []
        responseJSON.packages.forEach(element => {

          let temp = element.description.split(",")
          let temp2 = []
          //iterate to remove space
          temp.forEach((item) => {

            let bundlingName = item.replace(/\s+/g, ' ').trim()
            if (bundlingName != "") {
              let bundling = bundlinglist.find((bundle) => bundle.bundlingName === bundlingName)
              temp2.push(bundling)
            }

          })

          tempPackage.push({
            newPackage: false,
            id: element.id,
            packageName: element.name,
            price: element.price,
            promo_price: element.promo_price,
            bundling: temp2
          })
        });

        setPackageList(tempPackage)


        let tempSchedule = []
        responseJSON.times.forEach((schedule) => {
          let tempSlot = []
          schedule.service_times.forEach((slot) => {
            tempSlot.push({
              newSlot: false,
              id: slot.id,
              name: slot.time_start + " - " + slot.time_end,
              timeStart: slot.time_start,
              timeEnd: slot.time_end
            })
          })

          //sort array nya
          tempSlot.sort((slota, slotb) => {
            if (slota.name < slotb.name) {
              return -1;
            }
            if (slota.name > slotb.name) {
              return 1;
            }
            return 0;
          })

          tempSchedule.push({
            newItem: false,
            day: schedule.date_available,
            slots: tempSlot
          })
        })


        setScheduleList(tempSchedule)



      },
      //failed
      () => {

      }
    )
  }


  useEffect(() => {
    const selectedDays = dayOpen.filter(day => day.checked).map(day => day.day);
    // if (selectedDays.length === 0) return "Pilih hari...";
    const indices = selectedDays.map((day) => {
      return dayOpen.findIndex((d) => d.day === day);
    });
    indices.sort((a, b) => a - b);

    // // Check if the selected days are consecutive
    const isConsecutive = indices.every((val, i, arr) => i === 0 || val - arr[i - 1] === 1);

    if (isConsecutive) {
      updateDayOfService(`${selectedDays[0]} - ${selectedDays[selectedDays.length - 1]}`);
    } else {
      updateDayOfService(selectedDays.join(", "));
    }
  }, [dayOpen])


  const getVenueScheduleClosedApi = () => {
    getVenueScheduleClosed(
      venueId,
      //success
      (responseJSON) => {
        setScheduleClosedList(responseJSON)
      },
      //failed
      () => {

      }
    )
  }

  useEffect(() => {
    if (venueId != null) {
      getVenueDetailApi()
      getVenueScheduleClosedApi()
    }
  }, [venueId])


  const prepareMultipartForm = () => {
    setLoading(true)

    const validateResult = validateForm()

    if (validateResult.isValid) {

      const formData = new FormData();

      formData.append("[service][sport_type]", venueType)
      formData.append("[service][name]", venueName)
      formData.append("[service][location]", venueAddress)
      formData.append("[service][description]", venueDesc)
      formData.append("[service][latitude]", venueLat)
      formData.append("[service][longitude]", venueLong)

      const temp1 = [...attachments]
      temp1.forEach((element, i) => {
        formData.append("[service_images][image_name]["+i+"]", element)
      });
      formData.append("[service][cover]", venueImage)
      formData.append("[service][day_of_service]", venueDayOfService)
      formData.append("[service][open_hour]", venueOpenHour)
      formData.append("[service][close_hour]", venueCloseHour)
      formData.append("[service][is_dp]", venueIsDp)
      formData.append("[service][minimal_dp]", venueMinimalDp)
      formData.append("[service][terms_of_service]", venueTos)

      let facility = ""
      selectedAddOns.forEach(element => {
        facility = facility + element.name + ", "
      });

      formData.append("[service][facilities]", facility)

      formData.append("[service][service_category_id]", 1)

      let idxTimes = 0
      dayOpen.filter(item => item.checked).forEach((day) => {
        day.service_times_attributes.forEach((item) => {
          // console.log(day.id);
          if (item.id !== null) {
            formData.append("[service][service_times_attributes][" + idxTimes + "][id]", item.id)
            if (item._destroy !== undefined) {
              formData.append("[service][service_times_attributes][" + idxTimes + "][_destroy]", item._destroy)
            }
          }
          formData.append("[service][service_times_attributes][" + idxTimes + "][day]", day.day)
          formData.append("[service][service_times_attributes][" + idxTimes + "][time_start]", item.time_start)
          formData.append("[service][service_times_attributes][" + idxTimes + "][time_end]", item.time_end)
          formData.append("[service][service_times_attributes][" + idxTimes + "][price]", item.price)
          formData.append("[service][service_times_attributes][" + idxTimes + "][promo_price]", item.promo_price)
          formData.append("[service][service_times_attributes][" + idxTimes + "][promo_period]", item.promo_period)
          formData.append("[service][service_times_attributes][" + idxTimes + "][promo_period_start]", item.promo_period_start)
          formData.append("[service][service_times_attributes][" + idxTimes + "][promo_period_end]", item.promo_period_end)
          idxTimes = idxTimes + 1
        })
      })

      {
        props.action == "edit" ?
          //call API
          editVenue(venueId, formData,
            //success
            (responseJSON) => {
              showToast("Success", "Update Success", "Venue updated successfully")
              setTimeout(() => {
                window.location = '/'
              }, 2000)
            },
            //failed
            (message) => {
              showToast("Error", "Update Failed", message)
            }
          )
          :
          //call API
          createVenue(formData,
            //success
            (responseJSON) => {
              showToast("Success", "Create Success", "Venue created successfully")
              setTimeout(() => {
                window.location = '/'
              }, 2000)
            },
            //failed
            (message) => {
              showToast("Error", "Create Failed", message)
            }
          )
      }


    } else {
      showToast("Error", "Failed", validateResult.validationMessage)
    }
  }

  const prepareScheduleClosed = () => {
    setLoading(true)

    const formData = new FormData();

    formData.append("[service][service_category_id]", 1)

    scheduleClosedList.forEach((item, index) => {
      formData.append("[service][service_closes_attributes][" + index + "][id]", item.id)
      formData.append("[service][service_closes_attributes][" + index + "][date_closed]", item.date_closed)
      let isDestroy = 0
      if (item.date_closed === selectedDate) {
        isDestroy = 1
      }
      formData.append("[service][service_closes_attributes][" + index + "][_destroy]", isDestroy)
    });
    if (!isScheduleClosed(selectedDate)) {
      formData.append("[service][service_closes_attributes][" + scheduleClosedList.length + "][date_closed]", selectedDate)
      formData.append("[service][service_closes_attributes][" + scheduleClosedList.length + "][description]", closeNote)
      formData.append("[service][service_closes_attributes][" + scheduleClosedList.length + "][_destroy]", 0)
    }


    //call API
    updateVenueScheduleClosed(venueId, formData,
      //success
      (responseJSON) => {
        showToast("Success", "Update Success", "Schedule updated successfully")
        setTimeout(() => {
          // window.location = '/'
          // getVenueScheduleClosedApi()
          window.location.reload();
        }, 2000)
      },
      //failed
      (message) => {
        showToast("Error", "Update Failed", message)
      }
    )

  }

  const validateForm = () => {

    // if (props.action != "edit") {
    // if (venueImage == null) {
    //   return {
    //     isValid: false,
    //     validationMessage: "Please insert venue image"
    //   }
    // }

    // if (attachments.length == 0) {
    //   return {
    //     isValid: false,
    //     validationMessage: "Please insert venue attachments"
    //   }
    // }
    // }

    if (venueName == "") {
      return {
        isValid: false,
        validationMessage: "Please input venue name"
      }
    }

    // if (venueDesc == "") {
    //   return {
    //     isValid: false,
    //     validationMessage: "Please input venue description"
    //   }
    // }

    // if (venueDayOfService == "") {
    //   return {
    //     isValid: false,
    //     validationMessage: "Please input venue day of service"
    //   }
    // }

    // if (venueOpenHour == "") {
    //   return {
    //     isValid: false,
    //     validationMessage: "Please input venue open hour"
    //   }
    // }

    // if (venueCloseHour == "") {
    //   return {
    //     isValid: false,
    //     validationMessage: "Please input venue close hour"
    //   }
    // }

    let idxTimes = 0
    dayOpen.filter(item => item.checked).forEach((day) => {
      day.service_times_attributes.forEach((item) => {
        idxTimes = idxTimes + 1
      })
    })

    if (idxTimes == 0) {
      return {
        isValid: false,
        validationMessage: "Please input schedule"
      }
    }

    // if (venueTos == "") {
    //   return {
    //     isValid: false,
    //     validationMessage: "Please input venue privacy and policy"
    //   }
    // }

    return {
      isValid: true,
      validationMessage: ""
    }

  }

  const handleAddress = (lat, lng, address) => {

    setVenueLat(lat)
    setVenueLong(lng)
    setVenueGeocodeAddress(address)

  }


  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  const handleAttachmentClick = event => {
    attachmentsRef.current.click();
  };

  const onFileChange = (event) => {
    setVenueImage(event.target.files[0])
    setVenueImageUrl(URL.createObjectURL(event.target.files[0]));
  }

  const onAttachmentChange = (event) => {
    let urlTemp = []
    setAttachments(event.target.files)
    for (let i = 0; i < event.target.files.length; i++) {
      urlTemp.push(URL.createObjectURL(event.target.files[i]))
    }
    setAttachmentsUrl(urlTemp);
  }

  const addNewPriceList = (day) => {
    const updatedDay = { ...day };

    updatedDay.service_times_attributes.push({
      id: null,
      time_start: "",
      time_end: "",
      price: "",
      promo_price: "",
      promo_period: "",
      promo_period_start: "",
      promo_period_end: "",
    });

    setDayOpen(prevDayOpen =>
      prevDayOpen.map(d => (d.day === updatedDay.day ? updatedDay : d))
    );
  };


  const addNewPromo = (day, item, index) => {
    const updatedDay = { ...day };

    const newPromo = {
      id: null,
      time_start: item.time_start,
      time_end: item.time_end,
      price: item.price,
      promo_price: "",
      promo_period: "",
      promo_period_start: "",
      promo_period_end: "",
    };

    // Remove the restriction
    updatedDay.service_times_attributes.splice(index + 1, 0, newPromo);

    setDayOpen(prevDayOpen =>
      prevDayOpen.map(d => (d.day === updatedDay.day ? updatedDay : d))
    );
  };




  const clearPackageForm = () => {
    setPackageName("")
    setPackagePrice("")
    setPackagePromoPrice("")
    setSelectedBundling([bundlinglist[0]])
  }

  const updatePackage = (dayIndex, timeIndex, attributes = {}) => {
    setDayOpen(prevDayOpen => {
      const updatedDays = [...prevDayOpen];
      const updatedTimes = [...updatedDays[dayIndex].service_times_attributes];
      updatedTimes[timeIndex] = {
        ...updatedTimes[timeIndex],
        ...attributes
      };
      updatedDays[dayIndex] = {
        ...updatedDays[dayIndex],
        service_times_attributes: updatedTimes
      };
      return updatedDays;
    });
  };


  const deletePriceList = (deletedPrice, index) => {
    setDayOpen((prevDayOpen) => {
      return prevDayOpen.map((day) => {
        if (day.day !== deletedPrice.day) return day;

        const updatedServiceTimes = [...day.service_times_attributes];

        if (updatedServiceTimes[index]?.id != null) {
          updatedServiceTimes[index] = {
            ...updatedServiceTimes[index],
            _destroy: 1,
          };
        } else {
          updatedServiceTimes.splice(index, 1);
        }

        return {
          ...day,
          service_times_attributes: updatedServiceTimes,
        };
      });
    });
  };



  const onAddOnSelected = (addOn) => {
    const selectedAddOnsTemp = [...selectedAddOns]
    const existIndex = selectedAddOnsTemp.findIndex(e => e.name == addOn.name)

    if (existIndex >= 0) {

      selectedAddOnsTemp.splice(existIndex, 1)

    } else {
      selectedAddOnsTemp.push(addOn)
    }

    setselectedAddOns(selectedAddOnsTemp)

  }


  const checkAddon = (addOn) => {
    const result = (selectedAddOns.length > 0) && (selectedAddOns.filter((e) => e.name == addOn.name).length > 0)

    return result
  }


  const getPriceByTimeIndex = (day, timeIndex) => {
    const activeItems = day.service_times_attributes.filter(item => item._destroy !== 1);
    return activeItems[timeIndex] || {
      time_start: "",
      time_end: "",
      price: "",
      promo_price: "",
      promo_period: "",
      promo_period_start: "",
      promo_period_end: "",
    };
  };

  const onDaySelected = (selectedDateStr) => {
    console.log("isReset :" + isReset)
    if (!isReset) {
      setSelectedDate(selectedDateStr)
      setIsOpenUpdateScheduleDialog(true)
    }
    setIsReset(false);
  }



  const renderPackageDay = (day, dayIndex) => {
    const activeItems = day.service_times_attributes.filter(item => item._destroy !== 1);

    return activeItems.map((item, timeIndex) => {
      const isMainSlot = timeIndex === 0 || activeItems[timeIndex - 1].time_start !== item.time_start;
      const isLastPromoSlot = timeIndex === activeItems.length - 1 || activeItems[timeIndex + 1].time_start !== item.time_start;

      return (
        <div key={`${day.day}-${timeIndex}`} className='flex w-full mb-4'>
          <div className='flex w-full flex-col gap-y-4 mr-12'>
            <div className='flex flex-row w-full gap-x-4'>
              <div className='flex w-2/6 flex-col gap-y-4'>
                <div className='flex w-full gap-x-4'>
                  <div className='flex w-1/2'>
                    {isMainSlot && (
                      <InputMask
                        mask="99:99"
                        maskChar={null}
                        value={item.time_start}
                        onChange={(e) => updatePackage(dayIndex, timeIndex, { time_start: e.target.value })}
                        placeholder="Jam Mulai"
                        className={`w-1/2 ${inputClass} h-10`}
                      >
                        {(inputProps) => <input type="text" {...inputProps} />}
                      </InputMask>
                    )}
                  </div>
                  <div className='flex w-1/2'>
                    {isMainSlot && (
                      <InputMask
                        mask="99:99"
                        maskChar={null}
                        value={item.time_end}
                        onChange={(e) => updatePackage(dayIndex, timeIndex, { time_end: e.target.value })}
                        placeholder="Jam Akhir"
                        className={`w-1/2 ${inputClass} h-10`}
                      >
                        {(inputProps) => <input type="text" {...inputProps} />}
                      </InputMask>
                    )}
                  </div>
                </div>
              </div>
              <div className='flex w-1/6'>
                {isMainSlot && (
                  <input
                    type="text"
                    value={item.price || ""}
                    onChange={(e) => updatePackage(dayIndex, timeIndex, { price: e.target.value })}
                    className={`w-1/2 ${inputClass} h-10`}
                    placeholder='Harga'
                  />
                )}
              </div>
              <div className='flex flex-col w-3/6 gap-y-4'>
                <div className='flex flex-row gap-x-4'>

                  <div className='flex w-1/3'>
                    <input
                      type="date"
                      value={item.promo_period_start || ""}
                      onChange={(e) => updatePackage(dayIndex, timeIndex, { promo_period_start: e.target.value })}
                      className={`w-1/2 ${inputClass} h-10`}
                      placeholder='Periode Promosi'
                    />
                  </div>

                  <div className='flex w-1/3'>
                    <input
                      type="date"
                      value={item.promo_period || ""}
                      onChange={(e) => updatePackage(dayIndex, timeIndex, { promo_period: e.target.value })}
                      className={`w-1/2 ${inputClass} h-10`}
                      placeholder='Periode Promosi'
                    />
                  </div>
                  <div className='flex w-1/3'>
                    <input
                      type="text"
                      value={item.promo_price || ""}
                      onChange={(e) => updatePackage(dayIndex, timeIndex, { promo_price: e.target.value })}
                      className={`w-1/2 ${inputClass} h-10`}
                      placeholder='Harga Promosi'
                    />
                  </div>
                </div>
                {isLastPromoSlot && (
                  <div>
                    <button
                      onClick={() => addNewPromo(day, item, timeIndex)}
                      className='flex font-semibold items-center bg-primaryRed rounded-lg text-white px-4 text-xs py-2.5'>
                      Tambah Promosi
                    </button>
                  </div>
                )}
              </div>
              <div>
                <button
                  onClick={() => deletePriceList(day, timeIndex)}
                  className='flex font-semibold items-center bg-primaryRed rounded-lg text-white px-4 text-xs py-2.5'>
                  <TrashIcon className='w-5' />
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };


  const renderDataLapang = () => {
    return (<div className='p-6'>
      <div className='flex flex-row items-center justify-between gap-x-4'>
        <input
          type="text"
          value={venueName}
          onChange={(e) => setVenueName(e.target.value)}
          className={`${inputClass} h-10`}
          placeholder='Nama Lapang'
        />
        <div
          className={`${inputClass} h-10 `}>
          <select onChange={(e) => { setVenueType(e.target.value) }} className={"w-full bg-transparent text-gray-400"}>
            <option>Padel</option>
            <option>Badminton</option>
            <option>Futsal</option>
            <option>Mini Soccer</option>
            <option>Soccer</option>
            <option>Tennis</option>
            <option>Basketball</option>
          </select>
        </div>
      </div>

      {/* buat paket tersedia  */}
      <div className='mt-6 relative flex flex-col items-center border border-gray-300 rounded-lg overflow-hidden'>
        <p className='absolute left-0 top-0 px-3 bg-gray-200 py-1.5 rounded-br-lg text-sm font-semibold'>Harga Lapang</p>


        <div className='flex w-full flex-col mt-12 ml-12'>
          {dayOpen.filter(day => day.checked).map((day, index) => (
            <div key={index} className='flex flex-col mb-4'>
              <p className='flex text-md mb-4 font-semibold items-start justify-start'>{day.day.toUpperCase()}</p>

              {
                day.service_times_attributes.filter(item => item._destroy !== 1).length > 0 && (<div className=' flex w-full text-xs'>
                  <div className='flex w-full flex-col mr-10 mb-2'>
                    <div className='flex flex-row w-full text-xs'>
                      <div className='flex w-1/6'>Rentang Waktu</div>
                      <div className='flex w-1/6'></div>
                      <div className='flex w-1/6'>Harga Lapang</div>
                      <div className='flex w-1/6'>Periode Promosi</div>
                      <div className='flex w-1/6'></div>
                      <div className='flex w-1/6'>Harga Promosi</div>

                      <div
                        className='flex font-semibold items-center rounded-lg text-white px-4 text-xs'>
                        <TrashIcon className='w-5' />
                      </div>
                    </div>
                  </div>
                </div>)
              }

              {renderPackageDay(day, index)}

              {/* Adding the flex-grow div to push the button to the bottom */}
              <div className='flex-grow'></div>

              {/* Button moved to the right */}
              <div className='flex justify-start mr-14 gap-x-3'>
                <button
                  onClick={() => addNewPriceList(day)}
                  className='flex font-semibold items-center bg-primaryRed rounded-lg text-white px-4 text-xs py-2.5 gap-x-2'>
                  {/* <PlusCircleIcon className='w-6' />  */}
                  Tambah Jadwal
                </button>
              </div>

              <hr className='flex mr-12 mt-4' />
            </div>
          ))}
        </div>


        {props.action == "edit" ?
          <button onClick={() => { prepareMultipartForm() }} disabled={false}
            className={`mt-2 mb-6 ml-6 flex mr-auto w-fit px-12 text-white py-3 text-md font-semibold bg-primaryRed rounded-lg ${loading ? 'opacity-100' : ''}`}
          >
            <img src='/ic_send.png' className='w-5 h-5 mr-4' />
            Update Jadwal Lapang
          </button>
          :
          <button onClick={() => { prepareMultipartForm() }} disabled={false}
            className={`mt-2 mb-6 ml-6 flex mr-auto w-fit px-12 text-white py-3 text-md font-semibold bg-primaryRed rounded-lg ${loading ? 'opacity-100' : ''}`}
          >
            <img src='/ic_send.png' className='w-5 h-5 mr-4' />
            Buat Jadwal Lapang
          </button>
        }

      </div>
    </div>);
  };

  const renderJadwalTutup = () => {
    return (<div className='p-2'>
      <div className='flex flex-col gap-y-4'>
        {scheduleClosedList.map((item, index) => {
          return (
            <div key={index} className={'flex items-center justify-between w-full border border-primaryRed text-primaryRed text-sm rounded-lg pl-4 pt-4 pb-4 pr-2'}>
              <div>
                <p className='font-medium'>{item.date_closed}</p>
                <p className='font-medium'>{item.description}</p>
                </div>
              <span className=' flex items-center font-semibold cursor-pointer'
                onClick={(e) => {
                  setSelectedDate(item.date_closed);
                  setIsOpenUpdateScheduleDialog(true);
                }}>
                <TrashIcon className='w-5 h-5 mr-2' />
              </span>
            </div>
          )
        })}
      </div>
    </div>);
  };

  const renderJadwalLapang = () => {
    return (
      <div className='p-6'>
        <div className="w-full flex gap-x-4">
          <div className="flex-[6]">
            <DatePicker onDaySelected={onDaySelected} scheduleClosedList={scheduleClosedList} />
          </div>
          <div className="flex-[4]">
            <div className='flex flex-row'>
              <div className="flex flex-1 ml-2 mb-2">
                <p className="text-right font-bold">Jadwal Tutup</p>
              </div>
              {/* <div className="flex flex-1 justify-end items-center mr-2 mb-2">
                      <p className="text-right font-bold m-2">Pilih semua</p>
                      <input
                        id="checkbox-all-search"
                        type="checkbox"
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        ref={(el) => {
                          if (el) {
                            el.indeterminate = indeterminate;
                          }
                        }}
                      />
                      <label htmlFor="checkbox-all-search" className="sr-only">checkbox</label>
                    </div> */}
            </div>
            {renderJadwalTutup()}
          </div>
        </div>
      </div>
    );
  };


  const isScheduleClosed = (date) => {
    return scheduleClosedList.some(item => item.date_closed === date);
  };

  return (
    <div className='flex flex-col px-6 py-8 w-full bg-white rounded-2xl'>
      <p className='text-2xl text-start text-gray-800 font-bold'>
        {props.action == "edit" ?
          "Update Lapang"
          :
          "Buat Lapang"
        }
      </p>

      <div className='flex-1 rounded-lg border-2 mt-6 '>
        <Tabs onChange={handleTabChange} className='w-full'>
          <Tab label="Data Lapang">
            {renderDataLapang()}
          </Tab>
          <Tab label="Jadwal Lapang">
            {renderJadwalLapang()}
          </Tab>
        </Tabs>
      </div>

      <ConfirmationDialog
        title={isScheduleClosed(selectedDate) ? "Hapus jadwal tutup ?" : "Tambah jadwal tutup"}
        placeholderNote={"Keterangan tutup"}
        note={isScheduleClosed(selectedDate) ? undefined : closeNote}
        isOpen={isOpenUpdateScheduleDialog}
        onClose={() => {
          setIsOpenUpdateScheduleDialog(false)
        }}
        onConfirm={() => {
          setIsOpenUpdateScheduleDialog(false)
          prepareScheduleClosed()
        }}
        onNoteChange={(e) => {
          setCloseNote(e.target.value);
        }}
      />
    </div >
  );
}

export default CreateVenue;